import styled from 'styled-components'
import { VStack } from '../../../global/styles'

// eslint-disable-next-line import/prefer-default-export
export const TopSectionWrap = styled(VStack)`
  position: fixed;
  top: 0;
  height: calc(100% - 92px);
`
